export default Object.freeze({
  get(name) {
    let reg = new RegExp(`(^| )${name}=([^;]*)(;|$)`)
    let arr = document.cookie.match(reg)
    if (arr) {
      let value = unescape(arr[2])
      return +value + '' === value ? +value : value
    }
    return null
  },
  set(name, value) {
    document.cookie = `${name}=${escape(value)}`
  }
})
